import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MEError } from './me-error';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { ErrorDialog, MeErrorDialogComponent } from './me-error-dialog/me-error-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../services/loading/loading.service';
import { SystemUnavailableError } from '../components/system-unavailable/system-unavailable.component';

type DialogType = MEError | string;

@Injectable({
  providedIn: 'root'
})
export class MEErrorService {
  public systemAvailable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public systemUnAvailableError: BehaviorSubject<SystemUnavailableError> = new BehaviorSubject<SystemUnavailableError>({});

  private dlgError!: MatDialogRef<MeErrorDialogComponent, null>;
  public readonly VALIDATION_TITLE: string = 'ERROR_DIALOG.VALIDATION_ERROR';
  public readonly SERVER_TITLE: string = 'ERROR_DIALOG.SERVER_MESSAGE';
  private readonly REFERENCE_CODE: string = 'ERROR_DIALOG.REFERENCE_CODE';

  constructor(private srvDialog: MatDialog,
    private translate: TranslateService,
    private srvLoading: LoadingService) {
  }

  private readonly getDialogConfig = (data: ErrorDialog) => {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxWidth = 600;
    dialogConfig.width = '98%';
    dialogConfig.height = 'auto';
    dialogConfig.panelClass = 'custom-dialog-error-messages';
    return dialogConfig;
  };

  public showDialog(title: string, errors: DialogType[] | string, buttonText: string = 'ERROR_DIALOG.CLOSE_BTN', image?: string): Observable<null | undefined> {

    if (this.dlgError?.getState() == MatDialogState.OPEN) {
      this.dlgError.close();
    }

    let msgs: string[] = [];
    let referenceCode = this.translate.instant(this.REFERENCE_CODE);

    if (typeof errors == "string") {
      msgs.push(this.translate.instant(errors));
    }
    else {
      errors.forEach((error: DialogType) => {
        if (typeof error == 'string') {
          msgs.push(this.translate.instant(error));
        } else {
          let errorCode = (error.code > 0) ? `(${referenceCode}: ${error.code})` : '';
          msgs.push(`${error.message} ${errorCode}`);
        }
      })
    }

    let dataError: ErrorDialog = {
      title: this.translate.instant(title),
      msgs: msgs,
      buttonText: this.translate.instant(buttonText),
      image: image
    }

    let errorDialogConfig: MatDialogConfig = this.getDialogConfig(dataError);
    this.dlgError = this.srvDialog.open(MeErrorDialogComponent, errorDialogConfig)

    return this.dlgError.afterClosed();
  }

  public showErrorDialog(header: string, message: string, buttonText?: string, image?: string): Observable<null | undefined> {
    let tHeader = this.translate.instant(header);
    let tMessage = this.translate.instant(message);
    let tButtonText = buttonText ?? 'ERROR_DIALOG.CLOSE_BTN';
    return this.showDialog(tHeader, tMessage, tButtonText, image);
  }
}